import ClockIcon from 'components/ReusableComponents/Icons/Clock'
import CoinsIcon from 'components/ReusableComponents/Icons/Coins'
import GiftIcon from 'components/ReusableComponents/Icons/Gift'
import UserIcon from 'components/ReusableComponents/Icons/User'
import CalendarComplete from 'features/CustomCampaigns/EditCampaign/CalendarComplete'
import {
  getCampaignEstimation,
  TEXT_COST_PER_DAY
} from 'features/CustomCampaigns/EditCampaign/campaignEstimation'
import useCampaignCredits from 'hooks/useCampaignCredits'
import { formatPrice } from 'utils/common'
import { formatNumberAsThousands } from 'utils/priceHelpers'

import styles from './EditCampaign.module.scss'

const CustomCampaignEstimation = ({
  deliveryStartDate,
  deliveryFinishDate,
  guestsToText,
  guestsToEmail,
  totalGuestsToReach
}) => {
  const { credits } = useCampaignCredits()

  const { guestsWillBeReached, complimentaryTexts, campaignCost, estimatedEndDate } =
    getCampaignEstimation({
      deliveryStartDate,
      deliveryFinishDate,
      guestsToText,
      guestsToEmail,
      totalGuestsToReach,
      credits
    })

  return (
    <div className={styles.estimationHolder} id="text-blast-estimation">
      <div className={styles.estimatedEndDateHolder}>
        <CalendarComplete />
        <div className={styles.estimatedEndDateInner}>
          <p className={styles.estimatedEndDateLabel}> Estimated end date</p>
          <p className={styles.estimatedEndDateValue}>
            {estimatedEndDate.format('MMM D, YYYY')}{' '}
          </p>
        </div>
      </div>
      <div className={styles.estimationDetails}>
        <div className={styles.estimationDetailsRow}>
          <UserIcon width={20} />
          <p className={styles.estimationDetailText}>
            {formatNumberAsThousands(guestsWillBeReached)} guests will be reached
          </p>
        </div>
        {credits > 0 && (
          <div className={styles.estimationDetailsRow}>
            <GiftIcon width={20} />
            <p className={styles.estimationDetailText}>
              {complimentaryTexts} complimentary texts
            </p>
          </div>
        )}
        <div className={styles.estimationDetailsRow}>
          <CoinsIcon width={20} style={{ position: 'relative', left: 1 }} />
          <p className={styles.estimationDetailText}>
            {formatPrice(campaignCost)} approx. ({formatPrice(TEXT_COST_PER_DAY)} / text)
          </p>
        </div>
        <div className={styles.estimationDetailsRow}>
          <ClockIcon width={'1.3em'} height={'1.3em'} />
          <p className={styles.estimationDetailText}>
            Text will be sent around 5pm according to guest time zone
          </p>
        </div>
      </div>
    </div>
  )
}

export default CustomCampaignEstimation
